import $ from 'jquery';
import { createApp } from 'vue';
import ProductCrossSell from '../../../../assets/vue/components/ProductCrossSell/ProductCrossSell.vue';

const popup = $('.AddedToCartPopup');
let crossSellApp = null;
let crossSellRoot = null;

$(window).on('load', () => {
    popup.addClass('ready');
});

const showPopup = () => {
    popup.addClass('open');
    document.documentElement.style.overflowY = 'hidden';
};
const hidePopup = () => {
    popup.removeClass('open');
    document.documentElement.style.overflowY = 'auto';
};

$('.AddedToCartPopup').on('click', hidePopup);

$('.AddedToCartPopup__inner').on('click', function (ev) {
    ev.preventDefault();
    ev.stopImmediatePropagation();
});

function onSuccess(loadingCallback) {
    $(document.body).trigger('updated_cart_totals');
    $(document.body).trigger('wc_fragment_refresh');
    $(document.body).trigger('verenza_open_sidebar_cart');
    if (loadingCallback) {
        loadingCallback();
    }
    hidePopup();
}

const addProductsToCart = (products, loadingCallback) => {
    $.ajax({
        type: 'POST',
        url: jsData.ajaxUrl,
        data: {
            action: 'verenza_cross_sell_atc',
            products: JSON.stringify(products),
        },
        success: () => onSuccess(loadingCallback),
    });
};

const getProductCrossSells = (event, fragments, cartHash, button) => {
    if (button && $(button).is('[data-product-set-add]')) {
        return;
    }

    $.ajax({
        type: 'GET',
        url: jsData.ajaxUrl,
        data: {
            action: 'verenza_get_cross_sells_for_category',
        },
        success: (response) => {
            if (response.success) {
                if (!response.data.products.length) {
                    $(document.body).trigger('verenza_open_sidebar_cart');
                } else {
                    if (crossSellApp) {
                        crossSellApp.unmount();
                        crossSellApp = null;
                        crossSellRoot = null;
                    }
                    crossSellApp = createApp(ProductCrossSell, {
                        products: response.data.products,
                        addProductsToCart,
                        processToCart: onSuccess,
                    });
                    crossSellRoot = crossSellApp.mount('#app-popup-cross-sell');
                    showPopup();
                }
            }
        },
    });
};

$(document.body).on('added_to_cart', getProductCrossSells);

$('.AddedToCartPopup__continue, .SidebarCart__close ').on('click', hidePopup);
